function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import moment from "moment";

/*
 * Shared pieces for the Manage Data list tabs on the kit (Products, Audiences, Markets; dataflow
 * mockups 2026-10-09). Styles live in sass/v2/_data-lists.scss (every class dl-prefixed).
 */

/** "···" row menu (copied from views/reports/index.jsx RowMenu; the pop is position:fixed). */
export class RowMenu extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      open: false,
      pos: null
    });
    _defineProperty(this, "onDoc", e => {
      if (this._wrap && !this._wrap.contains(e.target)) this.close();
    });
    _defineProperty(this, "onKeyDoc", e => {
      if (e.key === "Escape") this.close();
    });
    _defineProperty(this, "close", () => {
      if (this.state.open) {
        this.unbind();
        this.setState({
          open: false
        });
      }
    });
    _defineProperty(this, "toggle", e => {
      e.stopPropagation();
      if (this.state.open) {
        this.close();
        return;
      }
      const r = e.currentTarget.getBoundingClientRect();
      const below = window.innerHeight - r.bottom > 260;
      this.setState({
        open: true,
        pos: below ? {
          top: r.bottom + 6,
          right: window.innerWidth - r.right
        } : {
          bottom: window.innerHeight - r.top + 6,
          right: window.innerWidth - r.right
        }
      });
      this.bind();
    });
  }
  componentWillUnmount() {
    this.unbind();
  }
  bind() {
    document.addEventListener("mousedown", this.onDoc);
    document.addEventListener("keydown", this.onKeyDoc);
    window.addEventListener("scroll", this.close, true);
    window.addEventListener("resize", this.close);
  }
  unbind() {
    document.removeEventListener("mousedown", this.onDoc);
    document.removeEventListener("keydown", this.onKeyDoc);
    window.removeEventListener("scroll", this.close, true);
    window.removeEventListener("resize", this.close);
  }
  render() {
    const {
      label,
      items
    } = this.props;
    const {
      open,
      pos
    } = this.state;
    const list = (items || []).filter(Boolean);
    if (!list.length) return null;
    return /*#__PURE__*/React.createElement("span", {
      className: "dl-menu",
      ref: el => {
        this._wrap = el;
      },
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "dl-menu-btn",
      "aria-label": `More for ${label}`,
      "aria-haspopup": "menu",
      "aria-expanded": open,
      onClick: this.toggle
    }, "\xB7\xB7\xB7"), open ? /*#__PURE__*/React.createElement("div", {
      className: "dl-menu-pop",
      role: "menu",
      style: pos
    }, list.map(it => /*#__PURE__*/React.createElement("button", {
      key: it.label,
      type: "button",
      role: "menuitem",
      className: it.danger ? "danger" : "",
      disabled: it.disabled,
      onClick: () => {
        this.close();
        it.onClick && it.onClick();
      }
    }, it.label))) : null);
  }
}

/** Card section with the mockup's title row: bold title, muted hint, then right-hand controls. */
export function DlCard({
  title,
  hint,
  right,
  cls = "",
  children
}) {
  return /*#__PURE__*/React.createElement("section", {
    className: `wa-card c12 dl-card ${cls}`
  }, title || hint || right ? /*#__PURE__*/React.createElement("div", {
    className: "dl-head"
  }, title ? /*#__PURE__*/React.createElement("b", {
    className: "dl-title"
  }, title) : null, hint ? /*#__PURE__*/React.createElement("span", {
    className: "dl-hint"
  }, hint) : null, /*#__PURE__*/React.createElement("span", {
    className: "dl-grow"
  }), right) : null, children);
}

/** Footer row under a table: optional amber/grey dot, a sentence, and a right-hand node. */
export function DlFoot({
  tone,
  children,
  right
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "dl-foot"
  }, tone ? /*#__PURE__*/React.createElement("span", {
    className: `dl-dot ${tone}`
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: "dl-grow"
  }, children), right);
}

/**
 * Prev / next pager over the server pagination object (functions/paginate.js shape:
 * page, pageCount, count, beginRecord, endRecord, prevPage/nextPage URLs). `onGo(url)`.
 */
export function DlPager({
  pagination,
  onGo,
  noun = "items"
}) {
  const p = pagination || {};
  const pages = Number(p.pageCount) || 1;
  const page = Number(p.page) || 1;
  if (pages <= 1) return null;
  const n = v => (Number(v) || 0).toLocaleString("en-US");
  const urlFor = target => {
    const hit = (p.pages || []).find(x => x.page === target);
    if (hit && hit.pageUrl) return hit.pageUrl;
    return target < page ? p.prevPage : p.nextPage;
  };
  return /*#__PURE__*/React.createElement("span", {
    className: "dl-pager"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dl-hint"
  }, p.beginRecord != null ? `${n(p.beginRecord)}–${n(p.endRecord)} of ${n(p.count)} ${noun}` : `Page ${page} of ${pages}`), /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: page <= 1,
    onClick: () => onGo(urlFor(page - 1))
  }, "Previous"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: page >= pages,
    onClick: () => onGo(urlFor(page + 1))
  }, "Next"));
}

/** "Today", "Yesterday", "Oct 2", "Oct 2, 2025". */
export function updatedLabel(v) {
  if (!v) return "";
  const m = moment(v);
  if (!m.isValid() || m.year() < 2000) return "";
  if (m.isSame(moment(), "day")) return "Today";
  if (m.isSame(moment().subtract(1, "day"), "day")) return "Yesterday";
  return m.isSame(moment(), "year") ? m.format("MMM D") : m.format("MMM D, YYYY");
}
export const fmtInt = v => (Number(v) || 0).toLocaleString("en-US");